import { render, staticRenderFns } from "./AproveMember.vue?vue&type=template&id=bb66a9b8&scoped=true"
import script from "./AproveMember.vue?vue&type=script&lang=js"
export * from "./AproveMember.vue?vue&type=script&lang=js"
import style0 from "./AproveMember.vue?vue&type=style&index=0&id=bb66a9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb66a9b8",
  null
  
)

export default component.exports